import PropTypes from 'prop-types';
import { track } from '@zillow/universal-analytics';
import newLaneEventProps from './newLaneEventProps';
export var ONSITE_MESSAGE_EVENT_CATEGORY = 'onsite_message';
export var ONSITE_MESSAGE_EVENT_ACTION = 'event';
export var NewLaneEvent = function NewLaneEvent(oldDspPayload, newLanePayload, gaPayload) {
  if (gaPayload === void 0) {
    gaPayload = {};
  }

  track(Object.assign({
    category: gaPayload.category || ONSITE_MESSAGE_EVENT_CATEGORY,
    action: gaPayload.action || ONSITE_MESSAGE_EVENT_ACTION,
    label: gaPayload.label || ''
  }, oldDspPayload), Object.assign({
    integrations: {
      GaPlugin: true,
      gtm: false,
      cdp: false,
      DspPlugin: true
    }
  }, newLanePayload && {
    newLaneEvent: [newLanePayload, {
      integrations: {
        gtm: false
      }
    }]
  }));
};
NewLaneEvent.propTypes = {
  // eslint-disable-next-line zillow/react/forbid-prop-types
  oldDspPayload: PropTypes.object,
  newLanePayload: newLaneEventProps,
  gaPayload: PropTypes.shape({
    action: PropTypes.string,
    category: PropTypes.string,
    label: PropTypes.string
  })
};
NewLaneEvent.defaultProps = {
  oldDspPayload: {},
  newLanePayload: {},
  gaPayload: {}
};